<template>
	<div id="sideverify">
		<el-dialog
      title="请拖动滑块继续学习"
      width="25%"
      :visible="dialogTableVisible"
      :lock-scroll="true"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false"
      :center="true"
      top="35vh"
    >
    <div class="verify-wrap" id="verify-wrap"></div>
		</el-dialog>
	</div>
</template>

<script>
import SlideVerifyPlug from '@/assets/js/jq-slideVerify'
import { updateStudyTime } from '@/service/api/methods/educationCloud';

export default {
  watch:{
    '$store.state.dialogVisible.dialogVisible':{
      handler:function(dialogVisible){
        this.dialogTableVisible = dialogVisible;
        if(dialogVisible){
          this.$store.commit('STOP_HANGUP');
          this.$nextTick(()=>{
            this.createSlideVerify();
          })
        }
      },
      immidate:true,
    },

  },
  data(){
    return{
        dialogTableVisible : false,
      }
    },
    computed:{
      dialogVisibleF:function(){
        return this.$store.state.dialogVisible.dialogVisible
      }
    },
    mounted(){
      this.$nextTick(()=>{
        this.createSlideVerify();
        this.dialogTableVisible = this.dialogVisibleF;
      })
    },

	methods:{
    //创建验证框
    createSlideVerify(){
        this.$store.commit('STOP_TIMER');
        this.$utils.endStudy();
        if(this.$route.name == 'videoDetails'){
          $('#video').trigger('pause');
        }
        var SlideVerifyPlug = window.slideVerifyPlug;
        setTimeout(()=>{//解决滑块弹回bug
          var slideVerify = new SlideVerifyPlug('#verify-wrap',{
            initText:'请按住滑块，拖到最右边',  //设置初始的显示文字
            sucessText:'验证成功',//设置验证通过显示的文字
            getSuccessState:res=>{
              //当验证完成的时候会返回 res 值 true
              this.dialogTableVisible = this.dialogVisibleF;
              if(res){
                if(this.$route.name == 'videoDetails'){
                  $('#video').trigger('play');
                }
                setTimeout(()=>{//异步处理
                  slideVerify.resetVerify();//重置
                  this.reset();
                },100)
              }
            }
          });
        },100)

    },
    //验证完毕后重置一些设置
    reset(){
      //更新开始学习时间
      this.$utils.beginStudy();
      //重置验证弹出框
      this.$store.commit('RESET_DIALOG');
      //重置验证计时器
      this.$store.commit('RESET_HANGUP');
      //验证计时器开始
      this.$store.commit('START_HANGUP');
      //考试倒计时继续
      this.$store.commit('START_TIMER')

    },

	},

}
</script>

<style lang="less" scoped>

</style>

